import { nameOf } from '../../../app/shared/common';
import { QueryParser } from '../../../app/shared/QueryParser';

export class PricelistListingQuery {
  phrase?: string;
}

export const PHRASE = nameOf<PricelistListingQuery>('phrase');

export class PricelistListingQueryParser extends QueryParser {
  public static toModel(query: Map<string, string>): PricelistListingQuery {
    const queryModel = new PricelistListingQuery();

    queryModel.phrase = QueryParser.getValue(query, PHRASE, '');

    return queryModel;
  }

  public static toQuery(queryModel: PricelistListingQuery): Map<string, string> {
    const query = new Map<string, string>();

    QueryParser.setValue(query, PHRASE, queryModel.phrase);

    return query;
  }
}
